export default {
  sm: `
  친환경
  데이터센터의
  시작
  `,
  md: `
  친환경 데이터센터의 시작
  `
};
